import getCompanyAssociatedTags from '../../../actions/api/tag/getCompanyAssociatedTags';
import {
  SUCCESS_API_GET_COMPANY_TAG_SET,
  SET_TAGS_FOR_LEVEL,
} from '../../../actions/actionTypes';

/**
 * 指定された階層のタグ(タグセットを含む)をAPIから取得する関数。
 *
 * @param {string} apiToken - APIリクエストのための認証トークン。
 * @param {string} parentId - 親タグのID。特定の親タグに関連する子タグを取得するために使用される。タグセットの場合は`null`を指定する。
 * @param {number} currentDepth - 取得するタグの階層。階層0はタグセットを指し、階層1, 2, 3...はそれぞれの階層に特有のタグを指す。
 * @returns {Function} Reduxのdispatch関数。取得したタグをストアにセットするアクションを実行する。
 */
const getTagsForLevel = (apiToken, parentId, currentDepth) => dispatch => {
  let actionType;
  if (currentDepth === 0) {
    actionType = SUCCESS_API_GET_COMPANY_TAG_SET;
  } else {
    actionType = SET_TAGS_FOR_LEVEL;
  }

  return dispatch(
    getCompanyAssociatedTags(
      apiToken,
      {
        depth: currentDepth,
        isDeleted: false,
        isUsable: null,
        parentId,
      },
      actionType,
    ),
  );
};

export default getTagsForLevel;
